import api from './api'

// 获取铺货成功的商品日志ID列表
function getMoveSuccessLogIdList(list) {
  const newList = []
  for (let item of list) {
    if (item.Status === 2) newList.push(item.Id)
  }
  return newList
}

// 获取铺货成功商品的审核结果
async function GetAuditStatusResult(list) {
  const logIds = getMoveSuccessLogIdList(list)
  if (!logIds.length) return
  const { result } = await api.GetAuditStatusResult(logIds.join())
  const map = result?.GoodAudit
  if (map) {
    for (let item of list) {
      const findItem = map[item.Id]
      if (findItem) {
        item.AuditStatusStr = findItem.AuditStatusStr
        item.EventReasons = findItem.EventReasons
        item.AuditStatusStrColor = findItem.AuditStatusStr?.includes('成功') ? 'blue' : 'red'
      }
    }
  }
}

export default {
  GetAuditStatusResult
}